import styled from '@emotion/styled'

type LanguageContainerProps = {
  selected?: boolean
}

export const Container = styled.div<LanguageContainerProps>`
  color: ${props => props.selected ? '#000' : '#777'};
  font-family: Satoshi;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  padding: 0.5rem;
  vertical-align: middle;

  &:hover {
    border: solid 1px #eee;
  }
`
